import type { CommonSVGProps } from './helpers';
import type { ColorValue } from '@frontend/constants';

export const StartSoonTaskBadge = ({ backgroundColor, clockColor, fill, ...props }: CommonSVGProps & { backgroundColor?: ColorValue; clockColor?: ColorValue }) => (
  <svg
    fill="none"
    viewBox="0 0 16 17"
    {...props}
  >
    <rect
      fill={backgroundColor}
      height={16}
      rx={8}
      width={16}
      y={0.5}
    />
    <path
      d="M4 4.5h8v8H4v-8Z"
      fill={fill}
    />
    <path
      d="M11.332 2.725a6.667 6.667 0 1 1-9.997 5.99l-.003-.216.003-.216a6.667 6.667 0 0 1 9.997-5.558ZM7.999 4.5a.667.667 0 0 0-.662.588l-.005.078V8.5l.006.087c.015.116.06.225.131.318l.058.067 2 2 .063.054a.667.667 0 0 0 .817 0l.063-.055.055-.063a.667.667 0 0 0 0-.817l-.055-.063-1.805-1.805V5.165l-.004-.078a.667.667 0 0 0-.662-.588Z"
      fill={clockColor}
    />
  </svg>
);
